import React, { Children } from 'react';
import { Phone, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="home" className="relative min-h-[90vh] flex flex-col items-center justify-center bg-[#1a3a2a] text-white overflow-hidden" data-id="element-64">
      {/* Subtle warm overlay/texture */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-65"></div>

      {/* Decorative top red line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-red-600" data-id="element-66"></div>

      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center mt-16" data-id="element-67">
        <motion.div variants={itemVariants} className="bg-white p-6 md:p-8 rounded-2xl shadow-2xl mb-10 max-w-md w-full transform -rotate-2 hover:rotate-0 transition-transform duration-400 border-b-4 border-red-600" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/p4iFB11LgfkFspQDPPQpex/PizzaWarehouse-Logo.jpg" alt="Pizza Warehouse Logo" className="w-full h-auto" data-id="element-69" />
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-3xl md:text-5xl font-heading font-bold mb-6 max-w-4xl leading-tight text-white tracking-wide" data-id="element-70">
          Our passion is all about creating amazing food with the freshest
          ingredients possible.
        </motion.h1>

        <motion.div variants={itemVariants} className="w-16 h-1 bg-red-600 mb-6 mx-auto" data-id="element-71"></motion.div>

        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-neutral-300 mb-12 max-w-2xl font-light" data-id="element-72">
          We make everything from scratch, every day, just for you!
        </motion.p>

        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 mb-16 w-full sm:w-auto" data-id="element-73">
          <a href="#menu" className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-full text-lg transition-colors shadow-lg shadow-red-600/30 font-heading tracking-wider flex items-center justify-center" data-id="element-74">
            VIEW OUR MENU
          </a>
          <a href="tel:270-933-1035" className="bg-white hover:bg-neutral-200 text-black font-bold py-4 px-8 rounded-full text-lg transition-colors flex items-center justify-center gap-2 font-heading tracking-wider" data-id="element-75">
            <Phone size={20} data-id="element-76" />
            (270) 933-1035
          </a>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10" data-id="element-77">
        <a href="#menu" className="text-neutral-500 hover:text-white transition-colors" aria-label="Scroll to menu" data-id="element-78">
          <ChevronDown size={40} data-id="element-79" />
        </a>
      </motion.div>
    </section>;
}